const POPUP_SETTINGS = 'scrollbars=no,toolbar=no,location=no,titlebar=no,directories=no,status=no,menubar=no';

export function getPopupOffset({width, height}) {
    const wLeft = window.screenLeft ? window.screenLeft : window.screenX;
    const wTop = window.screenTop ? window.screenTop : window.screenY;

    const left = wLeft + (window.innerWidth / 2) - (width / 2);
    const top = wTop + (window.innerHeight / 2) - (height / 2);

    return {top, left};
}

// using kind allows for different popups later (as in for SSO)
export function getPopupSize(kind) {
    switch(kind){
        default:
            return {width: 580, height: 550};
    }
}

export function getPopupDimensions(kind) {
    const {width, height} = getPopupSize(kind);
    const {top, left} = getPopupOffset({width, height});

    return `width=${width},height=${height},top=${top},left=${left}`;
}

export function openPopup(url, name, kind){
    const popup = window.open(url, name, `${POPUP_SETTINGS},${getPopupDimensions(kind)}`);
    const onUnloadHandler = function () {
        if (popup && !popup.closed) {
            popup.close();
        }
        window.removeEventListener('unload', onUnloadHandler);
    };
    window.addEventListener('unload', onUnloadHandler);
    return popup;
}
